import React, { useRef, useState } from "react";
import { FlowchartHeader } from "./FlowchartHeader";
import { FlowchartActions } from "./FlowchartActions";
import { FlowchartCanvas } from "./FlowchartCanvas";
import { FlowchartModal } from "./FlowchartModal";
import { useFlowchartExport } from "./hooks/useFlowchartExport";
import type { FlowchartData } from "@/lib/chat/parseFlowchartBlock";

interface FlowchartProps {
  data: FlowchartData;
}

export const Flowchart: React.FC<FlowchartProps> = ({ data }) => {
  const exportRef = useRef<HTMLDivElement>(null);
  const [expanded, setExpanded] = useState(false);
  const { exportPNG } = useFlowchartExport(exportRef, data.title);

  return (
    <>
      <div className="relative w-full overflow-hidden rounded-xl border border-border/60 bg-card shadow-sm">
        <div ref={exportRef}>
          <FlowchartHeader title={data.title} />
          <FlowchartCanvas data={data} />
        </div>
        <FlowchartActions
          onDownload={exportPNG}
          onExpand={() => setExpanded(true)}
        />
      </div>

      <FlowchartModal
        open={expanded}
        onClose={() => setExpanded(false)}
        data={data}
      />
    </>
  );
};
